import { EnquiryLifecycleStatusEnum, OrderTypeEnum, SourceFromEnum } from "../enum"
import { EnQuiryManagementProductReq } from "./enquiry-management-product-req"
import { EnquiryPackBomRequest } from "./enquiry-pack-bom.req"
export class EnquirymanagementReq{
    enquiryNumber:string
    // orderType:OrderTypeEnum
    sourceFrom:SourceFromEnum
    agentId:number
    buyerId:number
    salePersonId:number
    enquiryDate:Date
    noOfContainers:number
    agentAddressId:number
    buyerAddressId:number
    countryId:number
    destinationId:number
    etd:any
    toEtd : any
    eta:any
    deliveryTermsId:number
    paymentTermsId:number
    shipmentTermsId:number
    processingUnitId:number
    manufacturingUnitId:number
    currencyId:number
    remarks:string
    createdUser:string
    updateUser:string
    lifeCycleStatus:EnquiryLifecycleStatusEnum
    unitId:number
    enquiryRejectReason:number
    salesCommission:number
    uomId:number
    productDetails:EnQuiryManagementProductReq[]
    // enquiryPackBom: EnquiryPackBomRequest[]
    enquiryId?:number
    isFOB?:boolean
    constructor(
        enquiryNumber:string,
        // orderType:OrderTypeEnum,
        sourceFrom:SourceFromEnum,
        agentId:number,
        buyerId:number,
        salePersonId:number,
        enquiryDate:any,
        noOfContainers:number,
        agentAddressId:number,
        buyerAddressId:number,
        countryId:number,
        destinationId:number,
        etd:any,
        toEtd: any,
        eta:any,
        deliveryTermsId:number,
        paymentTermsId:number,
        shipmentTermsId:number,
        processingUnitId:number,
        manufacturingUnitId:number,
        currencyId:number,
        remarks:string,
        createdUser:string,
        updateUser:string,
        lifeCycleStatus:EnquiryLifecycleStatusEnum,
        unitId:number,
        enquiryRejectReason:number,
        salesCommission:number,
        uomId:number,
        productDetails:EnQuiryManagementProductReq[],
        // enquiryPackBom: EnquiryPackBomRequest[],
        enquiryId?:number,
        isFOB?:boolean

    ){
        this.enquiryNumber=enquiryNumber
        // this.orderType=orderType
        this.sourceFrom=sourceFrom
        this.agentId=agentId
        this.buyerId=buyerId
        this.salePersonId=salePersonId
        this.enquiryDate=enquiryDate
        this.noOfContainers=noOfContainers
        this.agentAddressId=agentAddressId
        this.buyerAddressId=buyerAddressId
        this.countryId=countryId
        this.destinationId=destinationId
        this.etd=etd
        this.toEtd = toEtd
        this.eta=eta
        this.deliveryTermsId=deliveryTermsId
        this.paymentTermsId=paymentTermsId
        this.shipmentTermsId=shipmentTermsId
        this.processingUnitId=processingUnitId
        this.manufacturingUnitId=manufacturingUnitId
        this.currencyId=currencyId
        this.remarks=remarks
        this.createdUser=createdUser
        this.updateUser=updateUser
        this.unitId=unitId
        this.lifeCycleStatus=lifeCycleStatus
        this.enquiryRejectReason=enquiryRejectReason
        this.salesCommission=salesCommission
        this.uomId = uomId
        this.productDetails=productDetails
        this.enquiryId=enquiryId
        this.isFOB = isFOB
        // this.enquiryPackBom = enquiryPackBom
    }

}